// extracted by mini-css-extract-plugin
export var select = "_pa-0";